import type { OrgForUser } from '../api/types';
import { safeReturnPath } from '../lib/callback';
import { KEYS, store } from '../lib/storage';

/**
 * State that has to survive the round trip to the wallet and back: where the
 * user was going, and an invite they opened before signing in. sessionStorage
 * keeps it to this tab.
 */

export function rememberReturnTo(path: string): void {
  const safe = safeReturnPath(path);
  if (safe && safe !== '/' && !safe.startsWith('/signin')) store.set(KEYS.returnTo, safe, 'session');
}

function takeReturnTo(): string | null {
  const v = safeReturnPath(store.get(KEYS.returnTo, 'session'));
  store.remove(KEYS.returnTo, 'session');
  return v;
}

export function rememberInvite(token: string): void {
  store.set(KEYS.pendingInvite, token, 'session');
}

export function pendingInvite(): string | null {
  return store.get(KEYS.pendingInvite, 'session');
}

export function clearInvite(): void {
  store.remove(KEYS.pendingInvite, 'session');
}

export function rememberOrg(orgId: string): void {
  store.set(KEYS.lastOrg, orgId);
}

/** Where to land once signed in. */
export function destinationAfterSignIn(orgs: OrgForUser[]): string {
  const invite = pendingInvite();
  if (invite) return `/invite/${encodeURIComponent(invite)}`;
  const back = takeReturnTo();
  if (back) return back;
  return homeFor(orgs);
}

export function homeFor(orgs: OrgForUser[]): string {
  if (orgs.length === 0) return '/welcome';
  const last = store.get(KEYS.lastOrg);
  const org = orgs.find((o) => o.id === last) ?? orgs[0]!;
  return `/orgs/${org.id}`;
}
